// Lightweight Google Analytics (gtag.js) integration
// Exposes: initAnalytics, trackPageview, trackEvent

let isInitialized = false;
let measurementId = null;

function loadGtagScript(id) {
  if (document.getElementById('gtag-js')) return;
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  script.id = 'gtag-js';
  document.head.appendChild(script);
}

function ensureDataLayer() {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  if (!window.gtag) {
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };
  }
}

export function initAnalytics(id, options = {}) {
  if (!id || isInitialized) return;

  const {
    respectDoNotTrack = true,
    sendPageViewOnInit = true,
  } = options;

  const dnt = (navigator.doNotTrack || window.doNotTrack || navigator.msDoNotTrack);
  if (respectDoNotTrack && (dnt === '1' || dnt === 'yes')) {
    return; // Respect DNT
  }

  measurementId = id;
  ensureDataLayer();
  loadGtagScript(id);

  window.gtag('js', new Date());
  window.gtag('config', id, { send_page_view: false });

  isInitialized = true;

  if (sendPageViewOnInit) {
    trackPageview(window.location.pathname + window.location.search);
  }
}

export function trackPageview(path) {
  if (!isInitialized || !measurementId) return;
  window.gtag('event', 'page_view', {
    page_path: path,
  });
}

export function trackEvent(action, params = {}) {
  if (!isInitialized) return;
  window.gtag('event', action, params);
}

export function isAnalyticsInitialized() {
  return isInitialized;
}

// Convenience domain-specific helpers
export const analyticsEvents = {
  gameStart(mode) {
    trackEvent('game_start', { mode });
  },
  gameWin({ mode, winner, playerWords, opponentWords }) {
    trackEvent('game_win', { 
      mode,
      winner,
      player_words: playerWords,
      opponent_words: opponentWords,
    });
  },
  themeToggled(newTheme) {
    trackEvent('theme_toggle', { theme: newTheme });
  },
  helpButtonClicked(location) {
    trackEvent('help_button_click', { location });
  },
  muteToggled(isMuted) {
    trackEvent('mute_toggle', { is_muted: !!isMuted });
  },
};


